import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? rem(44) : rem(32)};
    `;
  }}
`;

export const ColStyledDownloadLinkContainer = styled(Col)`
  .nmx-icon.badge-appStore {
    max-height: ${rem(40)};
  }
  .nmx-icon.badge-googlePlay {
    max-height: ${rem(60)};
    margin-top: ${rem(-10)};
  }
`;

export const ListItemStyled = styled.li`
  display: inline-block;
  vertical-align: top;
`;
